var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collection-panel"},[_c('AvailableCollectionDropdown',{staticClass:"collection-panel__dropdown",attrs:{"product":_vm.product}}),_c('p',{staticClass:"collection-panel__description"},[_vm._v(" "+_vm._s(_vm.$currentCollection.description[_vm.product.metal])+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }